export { Input as SearchMerchantsInput } from './input'
